import { setAppQuery } from '@src/mobile/utils/url';

export const groundsDispatch = async ({ to, type }) => {
    let url = to;

    if (type === 'web') {
        url = setAppQuery(url);
    }

    window.grounds.dispatch(type, url);
};
